<div class="loginWrap">

    <div class="leftPanel">
        <h2>Welcome to<br/>rail e-learning</h2>
        <!-- <div class="loginNav">
            <a href="">Privacy Policy</a>
            <a href="">Terms of Services</a>
            <a href="">Contact Us</a>
        </div> -->
    </div>
    <div class="rightPanel">
        <div class="loginContent">
            <h1><img src="assets/images/logo.svg" /> </h1>
            <div class="roleWrap">
                <h3>Login</h3>
            <div class="roleSelect">
                <mat-radio-group aria-label="Select an option" [formControl]="rdoUserTyp">
                    <mat-radio-button value="1" [routerLink]="['/']">As User</mat-radio-button>
                    <mat-radio-button value="2" [routerLink]="['/admin-login']">As Admin</mat-radio-button>
                </mat-radio-group>
            </div>
            </div>
            <form [formGroup]="loginForm">
                <div class="form-group">
                    <input type="email" class="form-control" formControlName="email" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Enter Email ID" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" >
                    <div *ngIf="submitted && f.email.errors">
                        <span *ngIf="f.email.errors.required" class="text-mute text-danger errorText">This field is required</span>
                        <span *ngIf="f.email.errors.pattern" class="text-mute text-danger errorText">Please provide a valid email address</span>
                    </div>
                </div>
                <div class="form-group">
                  <input type="password" class="form-control" formControlName="password" id="exampleInputPassword" placeholder="Enter Password" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" [type]="hide ? 'password':'text'">
                  <i class="iconEye adminEye" [class]="hide ? 'iconEye':'iconEye active'"  (click)="hide =!hide"></i>
                  <div *ngIf="submitted && f.password.errors">
                    <span *ngIf="f.password.errors.required" class="text-mute text-danger errorText">This field is required</span>
                </div>
                <div *ngIf="errorInfo.isError">
                    <span class="text-mute text-danger errorText">{{ errorInfo.errorMsg}}</span>
                </div>
                </div>
                <div class="forgot">
                    <a href="javascript:void(0);"  (click)="goToForgot()">Forgot Password?</a>
                </div>
                <button type="submit" class="btn btn-primary" (click)="loginUser(loginForm.value)" >Login</button>
               
              </form>
        </div>
        <!-- <div class="beforeContact">
            Do not have login and wish to get one? <a href="">Contact us</a> with your details
        </div> -->
    </div>
    <!-- <div class="loginNav mobileNave">
        <a href="">Privacy Policy</a>
        <a href="">Terms of Services</a>
        <a href="">Contact Us</a>
    </div> -->
</div>
